const errorLevel = [
    { id: -2, name: 'All' },
    { id: -1, name: 'None' },
    { id: 0, name: 'Minor' },
    { id: 1, name: 'Major' },
];

export { errorLevel };